import BaseApi from '@lumapps/base-api';
import { API_VERSION } from '@lumapps/base-api/types';
import { get } from '@lumapps/constants';

import { TOKEN_EXCHANGE_PATH } from './constants';
import { BeekeeperTokenResponse } from './types';

const { customerId, synUrl } = get();

/**
 * Path segment for organization-scoped endpoints
 */
export const getOrganizationPath = (customerId: string) => `${API_VERSION.v1}/organizations/${customerId}`;

const synApi = new BaseApi({
    baseURL: `${synUrl}/${getOrganizationPath(customerId)}`,
});

/**
 * Request Beekeeper token from Sync
 */
export const getBeekeeperToken = async () => {
    const { data } = await synApi.post<BeekeeperTokenResponse>(TOKEN_EXCHANGE_PATH, {});

    return data;
};
